import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ENVIRONMENT} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export abstract class DefaultWebservice {
  protected readonly path: string;
  protected readonly basePath: string = ENVIRONMENT.api.url;

  private readonly defaultRoute: string = 'api';

  protected readonly httpClient: HttpClient = inject(HttpClient);

  protected constructor(path: string = '') {
    this.path = `${this.basePath}/${this.defaultRoute}/${path}`;
  }
}
